import { ICommonIconProps } from "../types";


/**
 * -----------------------------------------------------------------------------
 * Renders a device with a badge check to represent a grade revised.
 */
export function GradeRevisedDeviceIcon({ className }: ICommonIconProps) {

  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        d="M8 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H15C16.1046 3 17 3.89543 17 5V9"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M13.5 3V5C13.5 5.27614 13.2761 5.5 13 5.5H9C8.72386 5.5 8.5 5.27614 8.5 5V3"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M14.75 16L15.75 17L17.25 15.5"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 14V18C22 19.6569 20.6569 21 19 21V21V22.4991C19 22.692 18.8889 22.8678 18.7146 22.9506C18.5403 23.0335 18.3339 23.0086 18.1843 22.8868L15.8673 21H13C11.3431 21 10 19.6569 10 18V14C10 12.3431 11.3431 11 13 11H19C20.6569 11 22 12.3431 22 14Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
